import { PARAM_SET } from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case PARAM_SET:
      return {
        ...state,
        list: action.params,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/param.js